import React from 'react'
import PropTypes from 'prop-types'
import { Column, Slider } from '@sainsburys-tech/bolt'
import { GetComponent } from '../components/CMSComponents'
import { SliderContainer } from './UGLayout.styles'
import { trackDataLayerEvent, eventNames } from './tracking'

const initialTracking = (heading) => {
  trackDataLayerEvent(
    eventNames.carouselViewed,
    {},
    {
      impressionValue: `carousel:banners:${heading}:1`,
      interactionValue: 'carousel:banners:impression'
    },
    'Carousel Viewed'
  )
}

const interactionTracking = (index, heading) => {
  trackDataLayerEvent(
    eventNames.carouselInteraction,
    {},
    {
      impressionValue: `carousel:banners:${heading}:${index}`,
      interactionValue: 'carousel:banners:chevron'
    },
    'Carousel Interaction'
  )
}

const slides = (included, consumingGridType) =>
  included.map((component, index) => {
    const sliderItem =
      consumingGridType === 'ug005' ? (
        <Column data-test='slider-container'>
          <GetComponent {...{ ...component, index }} />
        </Column>
      ) : (
        <SliderContainer
          xs={12}
          sm={6}
          block='md'
          md={4}
          lg={3}
          gutterSize='16px'
          numberOfColumns={12}
          data-test='slider-container'
          consumingGridType={consumingGridType}
        >
          <GetComponent {...{ ...component, index }} />
        </SliderContainer>
      )

    return sliderItem
  })

const UGSliderLayout = ({ included, consumingGridType }) => {
  const isUg004 = consumingGridType === 'ug004'
  const isUg005 = consumingGridType === 'ug005'
  const formattedHeading = (heading) => heading?.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')

  const slideProps = {
    itemsPerSlideXs: isUg004 ? 2 : 1,
    itemsPerSlideSm: isUg004 ? 2 : 1,
    itemsPerSlideMd: isUg004 ? 3 : 1,
    itemsPerSlideLg: isUg004 ? 4 : 1,
    itemsPerSlide: isUg005 ? 1 : undefined,
    isInfiniteCycle: true,
    numberOfSlides: isUg005 ? included.length : undefined,
    currentSlide: 1,
    showChevrons: true,
    onSlideChanged: isUg005
      ? (index) => interactionTracking(index, formattedHeading(included[index - 1]?.heading))
      : undefined,
    onSliderLoaded: isUg005 ? () => initialTracking(formattedHeading(included[0]?.heading)) : undefined
  }

  return <Slider {...slideProps} items={slides(included, consumingGridType)} />
}

UGSliderLayout.propTypes = {
  included: PropTypes.array.isRequired,
  consumingGridType: PropTypes.string.isRequired
}

export default UGSliderLayout
